import React from 'react';
import Modal from "@/components/ui/Modal";

export const LeadExecutionDocumentViewer = ({ isOpen, onClose, fileUrl, fileName }) => {
  if (!isOpen) return null;
  
  // Basic check for image vs pdf based on url/name
  const isImage = fileUrl?.match(/\.(jpeg|jpg|gif|png|webp|avif)$/i) || fileName?.match(/\.(jpeg|jpg|gif|png|webp|avif)$/i);
  
  const token = localStorage.getItem('blum_token') || localStorage.getItem('token') || '';
  const separator = fileUrl?.includes('?') ? '&' : '?';
  const fileUrlWithToken = fileUrl && !fileUrl.includes('token=') && token && (fileUrl.includes('/api/') || fileUrl.includes('/uploads/'))
    ? `${fileUrl}${separator}token=${token}`
    : fileUrl;
  
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={fileName || "Document Viewer"}
      size="4xl"
    >
      <div className="w-full h-[75vh] flex items-center justify-center bg-slate-100 rounded-lg overflow-hidden relative">
        {isImage ? (
          <img src={fileUrlWithToken} alt={fileName} className="max-w-full max-h-full object-contain" />
        ) : (
          <iframe 
            src={fileUrlWithToken} 
            title={fileName}
            className="w-full h-full border-0"
          />
        )}
      </div>
    </Modal>
  );
};
